var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9329 34.0818H28.8581V24.8001C28.8581 22.5868 28.8175 19.7376 25.6985 19.7376C22.5345 19.7376 22.0503 22.1491 22.0503 24.639V34.0812H15.9756V14.9943H21.8073V17.6027H21.889C22.4726 16.6291 23.316 15.8282 24.3293 15.2853C25.3426 14.7423 26.4879 14.4776 27.6431 14.5195C33.8003 14.5195 34.9355 18.4707 34.9355 23.611L34.9329 34.0818ZM9.12088 12.3854C7.17386 12.3857 5.5952 10.846 5.59488 8.94649C5.59456 7.04696 7.17258 5.5068 9.1196 5.50649C11.0666 5.50602 12.6453 7.04571 12.6456 8.94524C12.6458 9.85743 12.2745 10.7323 11.6135 11.3775C10.9525 12.0226 10.0559 12.3852 9.12088 12.3854ZM12.1584 34.082H6.07711V14.9943H12.1582V34.0818L12.1584 34.082ZM37.9615 0.00227036H3.02454C1.37332 -0.0158546 0.0192031 1.27461 -0.000976562 2.88555V37.1126C0.0185625 38.7243 1.37252 40.016 3.02438 39.9991H37.9615C39.6169 40.0191 40.9761 38.7274 40.999 37.1126V2.88289C40.9755 1.26883 39.6161 -0.0214796 37.9615 -0.000385886",
    fill: "#0A66C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.06a7be63570357676a9a0d68f9456efa.svg";
export { ForwardRef as ReactComponent };